import { Conflux } from 'js-conflux-sdk';
import { ethers } from "ethers";
import Lib from './Lib';
import axios from 'axios';
import moment from 'moment';

const BN = ethers.BigNumber;
const MAINNET = true;
const MAX_UINT = ethers.constants.MaxUint256;
let NETWORK_ID = 1;
let ADDRESS = require('./json/testnet.json');
let CUSDT_ADDRESS = 'cfxtest:acgcdeewrb2gtaxynwbezyfudypzay92cegvx0gj5c';
let EURL = 'https://testnet.confluxscan.io';
let NETWORK_URL = 'https://test.confluxrpc.com';

if (MAINNET) {
  NETWORK_ID = 1029;
  ADDRESS = require('./json/mainnet.json');
  CUSDT_ADDRESS = 'cfx:acf2rcsh8payyxpg6xj7b0ztswwh81ute60tsw35j7';
  EURL = 'https://confluxscan.io';
  NETWORK_URL = 'https://main.confluxrpc.com';
}

let TOKEN_ADDRESS = ADDRESS.TOKEN_ADDRESS;
let WARRIOR_ADDRESS = ADDRESS.WARRIOR_ADDRESS;
let WAR_ADDRESS = ADDRESS.WAR_ADDRESS;
let MOUNTAIN_ADDRESS = ADDRESS.MOUNTAIN_ADDRESS;

const ERC20_ABI = require('./json/ERC20Detailed.json').abi;
const WARRIOR_ABI = require('./json/Warrior.json').abi;
const WAR_ABI = require('./json/War.json').abi;
const MOUNTAIN_ABI = require('./json/Mountain.json').abi;

let cfx;
let account;
let cusdtContract;
let tokenContract;
let warriorContract;
let warContract;
let mountainContract;

function isWalletAvailable() {
  if (typeof window.conflux !== 'undefined') {
    return conflux.isConfluxPortal;
  }
  return false;
}

async function isConnectedToNetwork() {
  try {
    const check = await mountainContract.tokenToCoin('1000000000000000000');
    return true;
  } catch (err) {
  }
  return false;
}

async function connectToWallet() {

  // const networkVersion = conflux.networkVersion;
  // if (networkVersion !== NETWORK_ID) {
  //   console.error({ networkVersion });
  //   throw new Error('Wrong network. Please select TESTNET');
  // }

  cfx = new Conflux({
    networkId: NETWORK_ID,
  });
  cfx.provider = conflux;
  const accounts = await conflux.send("cfx_requestAccounts");
  account = accounts[0];
  cusdtContract = cfx.Contract({ abi: ERC20_ABI, address: CUSDT_ADDRESS });
  tokenContract = cfx.Contract({ abi: ERC20_ABI, address: TOKEN_ADDRESS });
  warriorContract = cfx.Contract({ abi: WARRIOR_ABI, address: WARRIOR_ADDRESS });
  warContract = cfx.Contract({ abi: WAR_ABI, address: WAR_ADDRESS });
  mountainContract = cfx.Contract({ abi: MOUNTAIN_ABI, address: MOUNTAIN_ADDRESS });

  const check = await isConnectedToNetwork();
  if (!check) throw new Error('Not connected to network.');
  // const tx = await cusdtContract.approve(WARRIOR_ADDRESS, MAX_UINT.toString()).sendTransaction({ from: account }).executed();
  // const txHash = tx.transactionHash;
  // console.log(txHash);

  // try {
  //   let logs = await warriorContract.WarriorSummoned().getLogs();
  //   console.log(logs);
  // } catch (err) {
  //   console.error(err);
  // }
}

async function getWalletData() {
  let gasBalance = await cfx.getBalance(account);
  gasBalance = ethers.utils.formatEther(gasBalance.toString());
  let cusdtBalance = await cusdtContract.balanceOf(account);
  cusdtBalance = ethers.utils.formatEther(cusdtBalance.toString());
  let tokenBalance = await tokenContract.balanceOf(account);
  tokenBalance = ethers.utils.formatEther(tokenBalance.toString());

  return {
    address: account,
    usdt: Math.floor(cusdtBalance * 100) / 100,
    gas: Math.floor(gasBalance * 100) / 100,
    token: Math.floor(tokenBalance * 100) / 100,
  };
}

const walletDataSubscribers = [];

function subscribeWalletData(cb) {
  walletDataSubscribers.push(cb);
}

async function publishWalletData() {
  const data = await getWalletData();
  for (let i = 0; i < walletDataSubscribers.length; i++) {
    const cb = walletDataSubscribers[i];
    cb(data);
  }
}

async function approveMint(amount) {
  const approveAmount = ethers.utils.parseUnits(amount + '');
  const tx = await cusdtContract.approve(WARRIOR_ADDRESS, approveAmount.toString()).sendTransaction({ from: account }).executed();
  const txHash = tx.transactionHash;
  return txHash;
}

async function getAllowanceMint() {
  let allowance = await cusdtContract.allowance(account, WARRIOR_ADDRESS);
  allowance = ethers.utils.formatEther(allowance.toString());
  return allowance.toString();
}

async function mint(amount) {
  const amountCoin = ethers.utils.parseUnits(amount + '');
  const tx = await warriorContract.summon(amountCoin).sendTransaction({ from: account }).executed();
  const txHash = tx.transactionHash;
  // const receipt = await cfx.getTransactionReceipt(txHash);
  // console.log(receipt.logs);
  return txHash;
}

function openExplorerTx(txHash) {
  Lib.openUrl(EURL + '/transaction/' + txHash);
}

function openExplorerNft() {
  const url = EURL + '/nft-checker/' + account;
  Lib.openUrl(url);
}

async function getFloorPrice() {
  let price = await mountainContract.tokenToCoin('1000000000000000000');
  price = ethers.utils.formatEther(price.toString());
  return price;
}

async function getGrowth() {
  let stats = await mountainContract.getStat();
  let startTime = Number(stats[0].toString());
  let startPrice = BN.from(stats[1].toString());
  let endPrice = BN.from(stats[2].toString());
  let diffPrice = endPrice.sub(startPrice);
  let now = moment().unix();

  const age = now - startTime;
  const oneDay = 3600 * 24;
  const oneYear = 3600 * 24 * 365;
  const pctg = diffPrice.mul(10000).div(startPrice);
  const pctgDaily = diffPrice.mul((10000 * oneDay)).div((startPrice.mul(age)));
  const pctgYearly = diffPrice.mul((10000 * oneYear)).div((startPrice.mul(age)));
  // const multiplier = oneYear * 100 * 100000;
  // const divider = startPrice.mul(dt);
  // const pctgYearly = profit.mul(multiplier).div(divider);

  const ret = {
    age,
    pctg: pctg.toNumber() / 100,
    pctgDaily: pctgDaily.toNumber() / 100,
    pctgYearly: pctgYearly.toNumber() / 100
  }
  return ret;
}

async function tokenToCoin(amount) {
  if (Number(amount) > 0) {
    const amountToken = ethers.utils.parseUnits(amount + '');
    let price = await mountainContract.tokenToCoin(amountToken);
    price = ethers.utils.formatEther(price.toString());
    return price;
  } else {
    return 0;
  }
}

async function approveSell(amount) {
  const approveAmount = ethers.utils.parseUnits(amount + '');
  const tx = await tokenContract.approve(MOUNTAIN_ADDRESS, approveAmount.toString()).sendTransaction({ from: account }).executed();
  const txHash = tx.transactionHash;
  return txHash;
}

async function getAllowanceSell() {
  let allowance = await tokenContract.allowance(account, MOUNTAIN_ADDRESS);
  allowance = ethers.utils.formatEther(allowance.toString());
  return allowance.toString();
}

async function sell(amount) {
  const amountToken = ethers.utils.parseUnits(amount + '');
  const tx = await mountainContract.buyBack(amountToken).sendTransaction({ from: account }).executed();
  const txHash = tx.transactionHash;
  return txHash;
}

async function getOwnedNFT() {
  let num = await warriorContract.balanceOf(account);
  num = Number(num.toString());
  const rows = [];
  for (let i = 0; i < num; i++) {
    let nftId = await warriorContract.tokenOfOwnerByIndex(account, i);
    nftId = Number(nftId.toString());
    const detail = await getDetailNFT(nftId);
    rows.push(detail);
    // const tokenURI = await warriorContract.tokenURI(nftId);
    // const response = await axios.get(tokenURI);
    // const image = response.data.image;
    // const name = response.data.name;
    // let stat = await warContract.getNftStat(nftId);
    // const power = Number(stat[2].toString());
    // stat = await warriorContract.getStat(nftId);
    // let collateral = Number(ethers.utils.formatEther(stat[1].toString()));
    // const ts = Number(stat[4].toString());
    // const rarity = Number(stat[5].toString());
    // let earning = await warContract.getTotalReward(nftId, 0);
    // earning = earning[0];
    // earning = Number(ethers.utils.formatEther(earning.toString()));
    // rows.push({ nftId: nftId, power: power, earning: earning, noPenaltyTime: ts, rarity, collateral, image, name });
  }

  return rows;
}

function toEth(bn) {
  return Math.floor(Number(ethers.utils.formatEther(bn.toString())) * 100) / 100;
}

async function getDetailNFT(nftId) {
  const tokenURI = 'https://39c5-104-248-156-222.ngrok.io/nft/' + nftId; // await warriorContract.tokenURI(nftId);
  const response = await axios.get(tokenURI);
  const image = response.data.image;
  const name = response.data.name;

  const warStat = await warContract.getNftStat(nftId);
  // nftId2connect[nftId],
  // nftId2turn[nftId],
  // nftId2power[nftId],
  // nftId2earning[nftId]

  const power = Number(warStat[2].toString());
  const claimedEarning = BN.from(warStat[3].toString());

  const warriorStat = await warriorContract.getStat(nftId);
  // (id, coll, genetic, createdTime, noFeeUnsummonTime, rarity);

  const collateral = BN.from(warriorStat[1].toString());
  const createdTime = Number(warriorStat[3].toString());
  const noFeeUnsummonTime = Number(warriorStat[4].toString());
  const rarity = Number(warriorStat[5].toString());

  let totalReward = await warContract.getTotalReward(nftId, 0);
  totalReward = BN.from(totalReward[0].toString());

  const age = moment().unix() - createdTime;
  const totalEarning = totalReward.add(claimedEarning);
  let totalEarningUsd = await mountainContract.tokenToCoin(totalEarning.toString());
  totalEarningUsd = BN.from(totalEarningUsd.toString());
  const pctg = totalEarningUsd.mul(10000).div(collateral);
  const pctgDaily = pctg.mul((3600 * 24)).div(age);
  const pctgYearly = pctg.mul((3600 * 24 * 365)).div(age);
  const ageDays = Math.floor((age / (3600 * 24)) * 100) / 100;
  const ret = {
    nftId: nftId,
    power: power,
    earning: toEth(totalReward),
    noPenaltyTime:
      noFeeUnsummonTime,
    rarity,
    collateral: toEth(collateral),
    image,
    name,
    age: ageDays,
    totalEarning: toEth(totalEarning),
    totalEarningUsd: toEth(totalEarningUsd),
    pctg: pctg.toNumber() / 100,
    pctgDaily: pctgDaily.toNumber() / 100,
    pctgYearly: pctgYearly.toNumber() / 100
  };

  return ret;
}


async function getNextSessionTime() {
  let stat = await warContract.getStat();
  let ts = Number(stat[4].toString());
  return ts;
}

async function retrieveReward(nftId) {
  const tx = await warContract.withdrawReward(nftId, 0).sendTransaction({ from: account }).executed();
  const txHash = tx.transactionHash;
  return txHash;
}

async function burn(nftId) {
  const tx = await warriorContract.unsummon(nftId).sendTransaction({ from: account }).executed();
  const txHash = tx.transactionHash;
  return txHash;
}

let readOnlyWallet = null;

async function getReadOnlyData() {
  if (!readOnlyWallet) {
    const pk = '0x1da6847600b0ee25e9ad9a52abbd786dd2502fa4005dd5af9310b7cc7a3b25db';
    readOnlyWallet = await getWallet(pk, NETWORK_URL, NETWORK_ID);
  }

  let price = await readOnlyWallet.mountain.tokenToCoin('1000000000000000000');
  price = ethers.utils.formatEther(price.toString());

  let stats = await readOnlyWallet.mountain.getStat();
  let startTime = Number(stats[0].toString());
  let startPrice = BN.from(stats[1].toString());
  let endPrice = BN.from(stats[2].toString());
  let diffPrice = endPrice.sub(startPrice);
  let now = moment().unix();

  const age = now - startTime;
  const oneDay = 3600 * 24;
  const oneYear = 3600 * 24 * 365;
  const pctg = diffPrice.mul(10000).div(startPrice);
  const pctgDaily = diffPrice.mul((10000 * oneDay)).div((startPrice.mul(age)));
  const pctgYearly = diffPrice.mul((10000 * oneYear)).div((startPrice.mul(age)));

  const ret = {
    price,
    age,
    pctg: pctg.toNumber() / 100,
    pctgDaily: pctgDaily.toNumber() / 100,
    pctgYearly: pctgYearly.toNumber() / 100
  }

  return ret;
}

function getWallet(
  privateKey,
  url,
  networkId
) {

  const conflux = new Conflux({
    url,
    networkId,
    // logger: console, // for debug
  });

  const wallet = {
    CUSDT_ADDRESS,
    WAR_ADDRESS,
    WARRIOR_ADDRESS,
    MOUNTAIN_ADDRESS
  };

  const account = conflux.wallet.addPrivateKey(privateKey);

  wallet.conflux = conflux;
  wallet.account = account;
  wallet.myAddress = account.address;
  wallet.cusdt = conflux.Contract({ abi: ERC20_ABI, address: CUSDT_ADDRESS });
  wallet.token = conflux.Contract({ abi: ERC20_ABI, address: TOKEN_ADDRESS });
  wallet.warrior = conflux.Contract({ abi: WARRIOR_ABI, address: WARRIOR_ADDRESS });
  wallet.war = conflux.Contract({ abi: WAR_ABI, address: WAR_ADDRESS });
  wallet.mountain = conflux.Contract({ abi: MOUNTAIN_ABI, address: MOUNTAIN_ADDRESS });

  return wallet;
}

export {
  isWalletAvailable,
  isConnectedToNetwork,
  connectToWallet,
  getWalletData,
  subscribeWalletData,
  publishWalletData,
  getAllowanceMint,
  approveMint,
  mint,
  openExplorerTx,
  openExplorerNft,
  tokenToCoin,
  getFloorPrice,
  getAllowanceSell,
  approveSell,
  sell,
  getOwnedNFT,
  getNextSessionTime,
  retrieveReward,
  burn,
  getGrowth,
  getDetailNFT,
  getReadOnlyData
};


